import { UploadedFreight } from '@retail/freight/types';
import { toConditionBinding, CreateCalculusConditions } from '@retail/calculus/types';
import { getISO_8601Date } from '@retail/utils';

interface Props {
  validFreights: UploadedFreight[];
  supplierNumber: number;
}

export const getImportedFreightConditions = ({ validFreights, supplierNumber }: Props) => {
  return validFreights.map((freight) => {
    return {
      content: {
        freight: freight.percentAddon ? { percentAddon: freight.percentAddon } : undefined,
        freightFixed:
          freight.fixedAddon && freight.fixedAddonUnit
            ? { fixedAddOn: freight.fixedAddon, fixedAddOnUnit: freight.fixedAddonUnit }
            : undefined,
      },
      binding: toConditionBinding({
        supplierNumber,
        groupNumber: freight.productGroupNumber,
        groupCode: freight.discountGroupCode,
        mgItemNumber: freight.mgItemNumber,
      }),

      validFrom: getISO_8601Date(freight.validFrom),
    } satisfies CreateCalculusConditions;
  }) as CreateCalculusConditions[];
};
